import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const MODULES = [
  { to: '/admin/services', label: 'Services' },
  { to: '/admin/billings', label: 'Billings and Customers' },
  { to: '/admin/projects', label: 'Projects' },
  { to: '/admin/canvas-despatch', label: 'Canvas Despatch' },
  { to: '/admin/canvas-library', label: 'Canvas Library' },
  { to: '/admin/qr-payment', label: 'QR Payment' },
  { to: '/admin/system-access', label: 'System Access' },
];

export default function AdminLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="admin-shell">
      <header className="admin-topbar">
        <div className="admin-topbar-inner">
          <span className="admin-brand">Canvas Memories</span>

          <nav className="admin-nav">
            {MODULES.map((m) => (
              <NavLink key={m.to} to={m.to} className={({ isActive }) => (isActive ? 'active' : '')}>
                {m.label}
              </NavLink>
            ))}
          </nav>

          <div className="admin-user-menu">
            <span className="admin-user-name">{user?.display_name || user?.username}</span>
            <button className="admin-btn admin-btn-secondary admin-btn-sm" onClick={handleLogout}>
              Sign out
            </button>
            <button
              className="admin-hamburger"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              ☰
            </button>
          </div>
        </div>

        <nav className={`admin-mobile-nav ${mobileOpen ? 'open' : ''}`}>
          {MODULES.map((m) => (
            <NavLink
              key={m.to}
              to={m.to}
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={() => setMobileOpen(false)}
            >
              {m.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
